import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 120000 });

const TOKEN_KEY = "reflip_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};

api.interceptors.request.use((c) => {
  const t = getToken();
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

// Auth
export const register = (p) => api.post("/auth/register", p).then((r) => r.data);
export const login = (p) => api.post("/auth/login", p).then((r) => r.data);
export const me = () => api.get("/auth/me").then((r) => r.data);

// Scan + items
export const scanItem = (image_base64) =>
  api.post("/scan", { image_base64 }).then((r) => r.data);
export const listItems = (status) =>
  api.get("/items", { params: status ? { status } : {} }).then((r) => r.data);
export const getItem = (id) => api.get(`/items/${id}`).then((r) => r.data);
export const createItem = (p) => api.post("/items", p).then((r) => r.data);
export const updateItem = (id, p) => api.put(`/items/${id}`, p).then((r) => r.data);
export const deleteItem = (id) => api.delete(`/items/${id}`).then((r) => r.data);
export const getStats = () => api.get("/stats").then((r) => r.data);

// Files
export const uploadFile = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};

// Marketplace
export const browseMarketplace = (params) =>
  api.get("/marketplace", { params }).then((r) => r.data);
export const getListing = (id) => api.get(`/marketplace/${id}`).then((r) => r.data);
export const getCouriers = () => api.get("/couriers").then((r) => r.data);

// Stripe checkout
export const createCheckoutSession = (payload) =>
  api.post("/checkout/session", payload).then((r) => r.data);
export const checkoutStatus = (sid) =>
  api.get(`/checkout/status/${sid}`).then((r) => r.data);

// Orders
export const myPurchases = () => api.get("/orders/mine").then((r) => r.data);
export const mySales = () => api.get("/orders/sales").then((r) => r.data);
export const getOrder = (id) => api.get(`/orders/${id}`).then((r) => r.data);
export const shipOrder = (id) => api.post(`/orders/${id}/ship`).then((r) => r.data);
export const deliverOrder = (id) => api.post(`/orders/${id}/deliver`).then((r) => r.data);
export const cancelOrder = (id) => api.post(`/orders/${id}/cancel`).then((r) => r.data);

// Messages
export const getMessages = (orderId) =>
  api.get(`/orders/${orderId}/messages`).then((r) => r.data);
export const sendMessage = (orderId, body) =>
  api.post(`/orders/${orderId}/messages`, { body }).then((r) => r.data);

// Reviews
export const postReview = (orderId, rating, comment) =>
  api.post(`/orders/${orderId}/review`, { rating, comment }).then((r) => r.data);
export const sellerReviews = (sellerId) =>
  api.get(`/sellers/${sellerId}/reviews`).then((r) => r.data);

// Stripe Connect payouts
export const connectStatus = () =>
  api.get("/account/connect/status").then((r) => r.data);
export const connectOnboard = (return_url) =>
  api.post("/account/connect/onboard", { return_url }).then((r) => r.data);
export const connectDisconnect = () =>
  api.delete("/account/connect").then((r) => r.data);

// Account / Bank
export const getProfile = () => api.get("/account/profile").then((r) => r.data);
export const updateProfile = (p) => api.put("/account/profile", p).then((r) => r.data);
export const updateBank = (p) => api.put("/account/bank", p).then((r) => r.data);
export const removeBank = () => api.delete("/account/bank").then((r) => r.data);

// Shipping label
export const getLabel = (orderId) =>
  api.get(`/orders/${orderId}/label`).then((r) => r.data);

// Notifications
export const getNotifications = () => api.get("/notifications").then((r) => r.data);
export const readAllNotifications = () =>
  api.post("/notifications/read-all").then((r) => r.data);

// Utils
export const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });

export const formatPrice = (n) => `£${Number(n || 0).toFixed(2)}`;

// Returns a usable <img src> for an item or order snapshot.
// Item shape: { images: [file_id, ...], image_base64?: legacy data url }
// Order shape: { item_image_id, item_image_base64 }
export const imageSrc = (obj) => {
  if (!obj) return null;
  if (obj.images && obj.images.length > 0) return `${API}/files/${obj.images[0]}`;
  if (obj.item_image_id) return `${API}/files/${obj.item_image_id}`;
  const b64 = obj.image_base64 || obj.item_image_base64;
  if (b64) return b64.startsWith("data:") ? b64 : `data:image/jpeg;base64,${b64}`;
  return null;
};

export const fileUrl = (file_id) => (file_id ? `${API}/files/${file_id}` : null);
